import { render, staticRenderFns } from "./CompanyInfo_UploadClassifiedDocs.vue?vue&type=template&id=93bf69b6&scoped=true"
import script from "./CompanyInfo_UploadClassifiedDocs.vue?vue&type=script&lang=js"
export * from "./CompanyInfo_UploadClassifiedDocs.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo_UploadClassifiedDocs.vue?vue&type=style&index=0&id=93bf69b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bf69b6",
  null
  
)

export default component.exports